import { render, staticRenderFns } from "./ProjectChangesSort.vue?vue&type=template&id=2e01ba1e"
import script from "./ProjectChangesSort.vue?vue&type=script&lang=js"
export * from "./ProjectChangesSort.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports